import { Route, Routes } from "react-router-dom";
import { Routes as FleetVehicleRoutes } from "./routes";
import { FleetVehicleRouterCmp } from "./types";
import { VehicleSearchPage } from "../pages";
import { VehicleDetailPage } from "../pages/VehicleDetailPage";
import { VehicleExpenseSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleExpenseSearchPage";
import { VehicleInvoiceSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleInvoiceSearchPage";
import { VehicleOfferSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleOfferSearchPage";
import { VehicleDriverSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleDriverSearchPage";
import { VehicleDocumentSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleDocumentSearchPage";
import { VehicleFireExtinguisherSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleFireExtinguisherSearchPage";
import { VehicleTireSetSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleTireSetSearchPage";
import VehicleContractSearchPage from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleContractSearchPage/VehicleContractSearchPage";
import { VehicleHistorySearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleHistorySearchPage";
import { VehicleTransferSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleTransferSearchPage";
import { VehicleDamageSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleDamageSearchPage";
import { VehicleServiceSearchPage } from "../pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleServiceSearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetVehicleRouter: FleetVehicleRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={VehicleSearchPage.route} element={<VehicleSearchPage />} />
        <Route path={VehicleDetailPage.route} element={<VehicleDetailPage />} />
        <Route
          path={VehicleDocumentSearchPage.route}
          element={<VehicleDocumentSearchPage />}
        />
        <Route
          path={VehicleExpenseSearchPage.route}
          element={<VehicleExpenseSearchPage />}
        />
        <Route
          path={VehicleFireExtinguisherSearchPage.route}
          element={<VehicleFireExtinguisherSearchPage />}
        />
        <Route
          path={VehicleInvoiceSearchPage.route}
          element={<VehicleInvoiceSearchPage />}
        />
        <Route
          path={VehicleOfferSearchPage.route}
          element={<VehicleOfferSearchPage />}
        />
        <Route
          path={VehicleContractSearchPage.route}
          element={<VehicleContractSearchPage />}
        />
        <Route
          path={VehicleTireSetSearchPage.route}
          element={<VehicleTireSetSearchPage />}
        />
        <Route
          path={VehicleDriverSearchPage.route}
          element={<VehicleDriverSearchPage />}
        />
        <Route
          path={VehicleDamageSearchPage.route}
          element={<VehicleDamageSearchPage />}
        />
        <Route
          path={VehicleServiceSearchPage.route}
          element={<VehicleServiceSearchPage />}
        />
        <Route
          path={VehicleTransferSearchPage.route}
          element={<VehicleTransferSearchPage />}
        />
        <Route
          path={VehicleHistorySearchPage.route}
          element={<VehicleHistorySearchPage />}
        />
      </Routes>
    </>
  );
};

FleetVehicleRouter.route = FleetVehicleRoutes.FleetVehicleRouter;

export default FleetVehicleRouter;
